var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chart-canvas',{attrs:{"option":_vm.option,"empty":_vm.empty}})
}
var staticRenderFns = []

export { render, staticRenderFns }